<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>Umowa zlecenie {{ shortNrUmowy() }}</strong>
</p>
<p>
    zawarta w Łodzi pomiędzy:
</p>

<p>
  Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, kapitał zakładowy 6 481 900,00 zł, reprezentowaną przez: 
</p>
<p>
  <strong>{{ zamawiajacy }}</strong>,
</p>
<p>zwaną dalej „<b>Zleceniodawcą</b>”,</p>
<p>a</p>
<p>Panią/Panem <b>{{ imieNazwisko }}</b>, zam. {{ zamieszkany }}, PESEL: {{ pesel }}</p>
<p>zwaną/ym w dalszej części Umowy „<b>Zleceniobiorcą</b>”,</p>
<p>zwanymi łącznie „<b>Stronami</b>”, a każdy z osobna „<b>Stroną</b>”.</p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<ol>
    <li>Przedmiotem niniejszej umowy (dalej „<b>Umowa</b>”), jest określenie warunków współpracy Stron w zakresie świadczenia przez Zleceniobiorcę na rzecz Zamawiającego usług związanych z czynnościami porządkowymi na warunkach i zasadach wskazanych w Umowie [dalej „<b>Usługi</b>”].</li>
    <li>Szczegółowy zakres czynności zleconych do wykonania w ramach Usług wskazany jest w <b>Załączniku nr 4</b> do Umowy.</li>
    <li>Zleceniobiorca oświadcza, że zapoznał się z misją i wizją Zleceniodawcy, przyjętymi u Zleceniodawcy standardami oraz obowiązującymi u Zleceniodawcy regulacjami wewnętrznymi oraz że w razie dokonania ich zmian, zmiany te będą obowiązywały Zleceniobiorcę od dnia powiadomienia go o zmianach. W szczególności, podczas wykonywania Usługi, Zleceniobiorca zobowiązany jest do dbania o dobro Zleceniodawcy i ochrony jego mienia, w tym do dołożenia najwyższej staranności celem zapewnienia zgodności wszystkich podejmowanych czynności z odpowiednimi politykami, standardami, wytycznymi, kodeksami branżowymi i procedurami (dalej łącznie „<b>Dokumenty</b>”) obowiązującymi u Zleceniodawcy. Zleceniodawca zobowiązuje Zleceniobiorcę do postępowania zgodnie z zasadami zawartymi w Dokumentach, a ich nieprzestrzeganie może być podstawą do wypowiedzenia Umowy przez Zleceniodawcę ze skutkiem natychmiastowym, z przyczyn leżących po stronie Zleceniobiorcy. Do szczególnych obowiązków Zleceniobiorcy należy przestrzeganie obowiązujących przepisów prawa, w tym w szczególności regulacji ustawy z dnia 6 czerwca 1997 roku – Kodeks karny.</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 2 Zasady świadczenia Usług</strong>
</p>
<ol>
  <li>Zleceniobiorca oświadcza, że dysponuje wiedzą, doświadczeniem oraz uprawnieniami niezbędnymi do należytego wykonania Usług i zobowiązuje się wykonywać je ze szczególną starannością, z uwzględnieniem obowiązujących przepisów prawa, standardów i reguł wykonywania prac objętych niniejszą Umową, dbając o interesy Zleceniodawcy.</li>
  <li>Obowiązki Zleceniobiorcy wynikające z Umowy Zleceniobiorca wykonywać będzie osobiście. Za uprzednią zgodą Zleceniodawcy wyrażoną na piśmie lub drogą mailową (w tym ostatnim przypadku za pośrednictwem upoważnionego przedstawiciela Zleceniodawcy, o którym mowa w § 8 ust. 1 Umowy), Zleceniobiorca może wykonywać Usługi z wykorzystaniem osób trzecich posiadających stosowne kwalifikacje (dalej „<b>Zastępca</b>”). Zleceniobiorca ponosi wobec Zleceniodawcy pełną odpowiedzialność za działania lub, odpowiednio, zaniechania Zastępcy jak za własne działania lub odpowiednio, zaniechania. Zleceniobiorca oraz Zastępca ponoszą solidarną odpowiedzialność za realizację zobowiązań wynikających z Umowy. Zleceniobiorca jest odpowiedzialny za rozliczenie z Zastępcą.</li>
  <li>Zleceniobiorca oświadcza, iż zawarcie i wykonywanie Umowy nie wymaga zgody osób trzecich, w tym instytucji państwowych.</li>
  <li>Strony ustalają, że Usługi będą świadczone przez Zleceniobiorcę w czasie ustalonym w sposób wskazany w ust. 5 poniżej przez Zleceniobiorcę, z uwzględnieniem zapotrzebowania Zleceniodawcy, w placówce Zleceniodawcy lub innym miejscu wskazanym przez Zleceniodawcę.</li>
  <li>Zleceniobiorca na minimum 5 dni przed rozpoczęciem danego miesiąca kalendarzowego (a w pierwszym miesiącu kalendarzowym obowiązywania Umowy na minimum 5 dni przed zaproponowanym przez Zleceniobiorcę pierwszym dniem realizacji Usług w ww. miesiącu) przedstawia Zleceniodawcy na piśmie lub drogą mailową (na adres e-mail upoważnionego przedstawiciela Zleceniodawcy, o którym mowa w § 8 ust. 1 Umowy) swoją dostępność, tj. propozycję czasu realizacji Usługi, przy czym Zleceniobiorca zobowiązuje się do niezwłocznego informowania Zleceniodawcy o każdorazowej zmianie wskazanej dostępności. W oparciu o przesłaną przez Zleceniobiorcę propozycję czasu realizacji Usług Zleceniodawca przedstawi Zleceniobiorcy <b>harmonogram realizacji Usług</b> obejmujący miesiąc kalendarzowy.</li>
  <li>W każdym czasie Zleceniodawca uprawniony jest do żądania od Zleceniobiorcy przedstawiania szczegółowych informacji na temat świadczonych Usług oraz dowodów ich wykonywania. Żądaniu temu Zleceniobiorca zobowiązany jest sprostać niezwłocznie.</li>
  <li>W każdym czasie Zleceniodawca uprawniony jest do żądania od Zleceniobiorcy przedstawiania szczegółowych informacji na temat świadczonych Usług oraz dowodów ich wykonywania. Żądaniu temu Zleceniobiorca zobowiązany jest sprostać niezwłocznie.</li>
  <li>Zleceniobiorca oświadcza, że został zapoznany z przepisami BHP, zagrożeniami związanymi ze świadczonymi Usługami. Zleceniobiorca potwierdza ten fakt podpisem na dokumencie: <b>Ogólne Zasady Bhp przy administracyjno-biurowej</b>, która stanowi <b>Załącznik nr 2</b> do Umowy.</li>
  <li>Zleceniobiorca przedstawia Zleceniodawcy zestawienie liczby godzin świadczenia Usług przez Zleceniobiorcę w każdym miesiącu kalendarzowym, w którym Usługi były wykonywane (dalej: „<b>Zestawienie liczby godzin</b>”) za pośrednictwem poczty elektronicznej (na adres e-mail upoważnionego przedstawiciela Zleceniodawcy, o którym mowa w § 8 ust. 1 Umowy) lub wewnętrznego systemu Zamawiającego udostępnionego Zleceniobiorcy, najpóźniej do 5-ego dnia miesiąca następującego po miesiącu kalendarzowym, którego ww. Zestawienie liczby godzin dotyczy. Jeżeli w danym miesiącu obowiązywania Umowy Usługi nie były wykonywane Zleceniobiorca wpisuje „0” w Zestawieniu liczby godzin.</li>
  <li>Zleceniodawca nie później niż w terminie 3 dni od otrzymania zestawienia liczby godzin potwierdza albo odmawia potwierdzenia liczby godzin świadczenia Usług. Informacja o potwierdzeniu albo odmowie potwierdzenia jest przekazywana Zleceniobiorcy za pośrednictwem poczty elektronicznej lub wewnętrznego systemu.</li>
  <li>Zleceniobiorca w terminie 3 dni od daty przekazania przez Zleceniodawcę odmowy potwierdzenia liczby godzin świadczenia Usług w danym miesiącu może wnieść reklamację do Zleceniodawcy, za pośrednictwem poczty elektronicznej lub pisemnie. W terminie 3 dni roboczych od daty otrzymania reklamacji Zleceniodawca informuje Zleceniobiorcę o sposobie rozpoznania reklamacji za pośrednictwem poczty elektronicznej lub w formie pisemnej.</li>
  <li>W celu uniknięcia wątpliwości Strony oświadczają, że Zleceniobiorca nie nabywa żadnych praw do jakichkolwiek materiałów przekazanych mu przez Zleceniodawcę w związku z realizacją Umowy (m.in. środków czystości, sprzętu do wykonywania czynności porządkowych, materiałów promocyjnych). Zleceniobiorca zobowiązuje się nie korzystać z ww. materiałów ani jakichkolwiek danych, do których uzyskał dostęp w związku z realizacją Umowy, w innym celu niż wykonanie Umowy.</li>
  <li>Strony zgodnie potwierdzają, że czas przygotowania do świadczenia Usług, reklamacji, wykonywania korekt lub poprawek nie jest wliczany do czasu świadczenia Usług.</li>
  <li>Zleceniobiorca oświadcza, że jego stan zdrowia pozwala na świadczenie Usług objętych Umową.</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 5px;">
  <strong>§ 3 Wynagrodzenie</strong>
</p>
<ol>
  <li>Zleceniodawca zobowiązuje się do wypłaty, z tytułu właściwego wykonywania Usług w danym miesiącu kalendarzowym wynagrodzenia w wysokości {{ kwota }} ({{ slowniepokaz }}) złotych brutto za każdą godzinę zegarową świadczonych na rzecz Zleceniodawcy Usług.</li>
  <li>Wynagrodzenie, o którym mowa w ust. 1 powyżej, będzie wypłacane na podstawie przygotowanego przez Zleceniobiorcę i zaakceptowanego przez Zleceniodawcę Zestawienia liczby godzin świadczonych Usług w miesiącu, za który dokonywana jest płatność.</li>
  <li>Wynagrodzenie będzie wypłacone przez Zleceniodawcę na wskazany rachunek bankowy Zleceniobiorcy w terminie do <b>15-tego</b> dnia kolejnego miesiąca. Termin wypłaty wynagrodzenia uzależniony jest od daty przekazania przez Zleceniobiorcę i akceptacji przez Zleceniodawcę Zestawienia liczby godzin świadczonych Usług w miesiącu, za który dokonywana jest płatność, przy czym Zestawienie liczby godzin świadczonych Usług powinno być przekazane <b>nie później niż 13 dni roboczych</b> przed planowaną datą wypłaty wynagrodzenia.</li>
  <li>Za dzień zapłaty uważa się dzień obciążenia rachunku bankowego Zleceniodawcy.</li>
  <li>Wynagrodzenie opisane powyżej stanowi całość zobowiązań Zleceniodawcy wobec Zleceniobiorcy z tytułu wykonania Umowy. </li>
  <li>Zleceniobiorca zobowiązuje się do przekazywania Zleceniodawcy wszelkich informacji niezbędnych dla prawidłowego obliczenia i odprowadzenia składek na ubezpieczenia społeczne oraz ubezpieczenie zdrowotne Zleceniobiorcy oraz ich aktualizacji. Zleceniobiorca ponosi odpowiedzialność za nieprawidłowe lub nieterminowe przekazanie informacji, o których mowa w zdaniu poprzednim.</li>
  <li>Zleceniobiorca wyraża zgodę na potrącenie z należnego mu wynagrodzenia kwoty kar umownych przewidzianych Umową.</li>
</ol>

<p align="center" style="margin-bottom: 0px;">
    <strong>§ 4 Standardy ochrony małoletnich</strong>
  </p>
    <p>Zleceniobiorca oświadcza, iż zapoznał się z zapisami dokumentu „Standardy ochrony małoletnich w Tutore Poland Sp. z o.o.” wprowadzonego przez Zleceniodawcę na mocy  ustawy z dnia 13 maja 2024 r. o ochronie małoletnich (Dz.U. 2024 poz. 560) i zobowiązuje się do jej przestrzegania. Naruszenie postanowień regulaminu będzie uznawane za istotne naruszenie obowiązków wynikających z niniejszej umowy i może skutkować jej natychmiastowym rozwiązaniem.</p>
  <br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 5 Odpowiedzialność</strong>
</p>
<ol>
  <li>Zleceniobiorca ponosi odpowiedzialność za szkodę wynikłą z niewykonania lub nienależytego wykonania Usług. Zleceniobiorca odpowiada za rzeczywistą, wyrządzoną szkodę oraz za ewentualną utratę korzyści Zleceniodawcy i jest zobowiązany do jej naprawienia w pełnej wysokości.</li>
  <li>W przypadkach, gdy szkoda poniesiona przez Zleceniodawcę na skutek zdarzeń stanowiących podstawę do żądania kary umownej zgodnie z postanowieniami Umowy, przewyższa wartość danej kary umownej, Zleceniodawca, poza żądaniem zapłaty takiej kary umownej, uprawniony będzie do dochodzenia odszkodowania w pełnej wysokości na zasadach ogólnych.</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 6 Klauzula poufności</strong>
  </p>
<ol>
    <li>Zleceniobiorca jest zobowiązany do zachowania w poufności wszelkich informacji i wiedzy, jak również wszelkich dokumentów i projektów dokumentów ujawnionych przez Zleceniodawcę lub do których Zleceniobiorca będzie miał dostęp w związku z realizacją Umowy, zarówno przed jak i po wejściu w życie Umowy, które:
        <ol type="a">
            <li>dotyczą Umowy lub Zleceniodawcy oraz jego działalności, w szczególności wszelkich informacji o charakterze ekonomicznym, handlowym lub organizacyjnym, jak również informacji odnoszących się do jej strategii, personelu i spraw finansowych lub przyszłych planów lub perspektyw, itp. oraz</li>
            <li>które nie zostały podane do publicznej wiadomości, oraz</li>
            <li>które Zleceniobiorca uzyskał lub które staną się mu znane w czasie obowiązywania Umowy, a także przed podpisaniem Umowy, niezależnie od tego, czy informacje te są w formie pisemnej, ustnej czy w jakiejkolwiek innej formie, jak również niezależnie od tego, czy informacje te, wiedza lub dokumenty są wyraźnie oznaczone, jako poufne (zwane dalej: „<b>Informacjami Poufnymi</b>”).</li>
        </ol>
    </li>
    <li>Zobowiązanie, o którym mowa w ust. 1 powyżej, jest wiążące od dnia podpisania Umowy i obowiązuje przez 3 lata po jej wygaśnięciu lub rozwiązaniu.</li>
    <li>Informacje Poufne ujawnione przez Zleceniodawcę w okresie obowiązywania Umowy lub do których Zleceniobiorca będzie miał dostęp w związku z podejmowanymi czynnościami dotyczącymi realizacji Umowy, będą wykorzystywane wyłącznie w zakresie bezpośrednio związanym z realizacją Umowy. Zleceniobiorca nie jest upoważniony do wykorzystywania Informacji Poufnych w celu prowadzenia własnej działalności gospodarczej lub działalności podmiotów trzecich.</li>
    <li>W razie naruszenia przez Zleceniobiorcę ww. zobowiązań, Zleceniobiorca zapłaci Zleceniodawcy karę umowną w wysokości 30 000 zł (słownie: trzydzieści tysięcy złotych) za każde ujawnienie lub wykorzystanie Informacji Poufnych w sposób sprzeczny z postanowieniami Umowy. Zleceniodawca jest uprawniony do dochodzenia naprawienia szkody w wysokości przenoszącej zastrzeżoną karę umowną.</li>
    <li>Zleceniobiorca, który ujawnia Informacje Poufne, stanowiące tajemnicę przedsiębiorstwa Zleceniodawcy innej osobie lub wykorzystuje je we własnej działalności gospodarczej, zgodnie z art. 23 ust. 1. Ustawy z dnia 16 kwietnia 1993 roku o zwalczaniu nieuczciwej konkurencji podlega grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2.</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 7 Klauzula antykorupcyjna</strong>
</p>
<ol>
  <li>Zleceniobiorca przyjmuje do wiadomości, że jedną z zasad działalności Zleceniodawcy jest przestrzeganie zakazu bezpośredniego lub pośredniego przekazywania jakichkolwiek korzyści majątkowych osobom pełniącym funkcje publiczne lub instytucjom publicznym i państwowym, w celu uzyskania lub utrzymania korzyści handlowych i zobowiązuje się do przestrzegania tej zasady. Na potrzeby niniejszej umowy, za osobę pełniąca funkcje publiczną rozumie się w szczególności dyrektora i nauczyciela szkoły publicznej lub prywatno-publicznej, zaś za instytucję publiczną – szkołę publiczną lub prywatno-publiczną.</li>
  <li>Zleceniobiorca przyjmuje do wiadomości, że stosowne przepisy prawa zabraniają, m.in. bezpośredniego lub pośredniego przekazywania korzyści majątkowych lub osobistych funkcjonariuszom publicznym, osobom pełniącym funkcje publiczne oraz innym urzędnikom państwowym, a także partiom politycznym lub ich kandydatom w celu uzyskania lub utrzymania korzyści biznesowych i zobowiązuje się przestrzegać te zasady.</li>
  <li>Zleceniobiorca zobowiązuje się przestrzegać zasad opisanych powyżej, w tym oświadcza, że wynagrodzenie, o którym mowa w § 4 niniejszej Umowy, jest świadczeniem ekwiwalentnym w stosunku do świadczeń wykonanych przez Zleceniobiorcę na podstawie Umowy i nie narusza zasad opisanych w ustępach poprzedzających.</li>
  <li>Zleceniobiorca oświadcza, że nie pozostaje w żadnej relacji służbowej lub osobistej, która mogłaby powodować podejrzenie, że zawarcie Umowy będzie sprzeczne z opisanymi powyżej zasadami. W przypadku podejrzenia zaistnienia takiej relacji, Zleceniobiorca zobowiązuje się niezwłocznie powiadomić o tym fakcie Zleceniodawcę. W takim przypadku Zleceniodawcy przysługuje prawo do natychmiastowego rozwiązania Umowy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 8 Czas trwania i rozwiązanie Umowy</strong>
</p>
<ol>
  <li>Umowa zostaje zawarta na czas określony tj. {{ dataObowiazywaniaUmowy() }}.</li>
  <li>Zleceniodawcy oraz Zleceniobiorcy przysługuje prawo wypowiedzenia Umowy w każdym czasie, bez podania przyczyny, z zachowaniem miesięcznego okresu wypowiedzenia, z zastrzeżeniem, że jeżeli Umowa zawarta jest na okres krótszy niż jeden miesiąc, okres wypowiedzenia wynosi 7 dni.</li>
  <li>Z zastrzeżeniem innych postanowień Umowy, Umowa może być rozwiązana przez Zleceniodawcę ze skutkiem natychmiastowym w przypadku naruszenia istotnych postanowień Umowy przez Zleceniobiorcę. W takim wypadku Zleceniodawca obowiązany jest doręczyć Zleceniobiorcy w formie pisemnej jasne i szczegółowe wyjaśnienie powstałych naruszeń i uzasadnić tym samym podstawę rozwiązania Umowy.</li>
  <li>Z chwilą wygaśnięcia Umowy, najpóźniej w dniu wygaśnięcia Umowy, Zleceniobiorca zobowiązany jest zwrócić Zleceniodawcy wszelkie przekazane mu przez Zleceniodawcę na potrzeby realizacji Usług materiały, sprzęt i narzędzia, pod rygorem zapłaty kary umownej w wysokości 1 000,00 złotych za każdy rozpoczęty dzień opóźnienia lub zwłoki w realizacji ww. zobowiązania.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 9 Postanowienia końcowe</strong>
</p>
<ol>
  <li>Zmiana lub uzupełnienie Umowy wymagają zachowania formy dokumentowej, pod rygorem nieważności.</li>
  <li>W sprawach nieuregulowanych Umową odpowiednie zastosowanie mają odpowiednie przepisy prawa polskiego w tym przepisy Kodeksu cywilnego.</li>
  <li>W przypadku, gdy którekolwiek z postanowień Umowy okaże się nieważne, bezskuteczne lub niewykonalne, pozostałe postanowienia Umowy będą ważne, skuteczne i wiążące tak jakby nie istniało postanowienie nieważne, bezskuteczne lub niewykonalne, a postanowienia nieważne, bezskuteczne lub niewykonalne zostaną zastąpione postanowieniami, które w najbliższy sposób odpowiadają pierwotnemu zamiarowi Stron w zakresie zgodnym z obowiązującym prawem.</li>
  <li>Jeżeli w czasie trwania Umowy stan prawny, który obowiązywał w czasie zawierania Umowy, zmieni się w ten sposób, że znaczenie, jakie strony nadały poszczególnym postanowieniom Umowy, się zmieni, a z przepisów prawa będzie wynikało, iż nowy stan prawny ma zastosowanie do stosunków prawnych regulowanych Umową, strony zobowiązują się do stosownej zmiany całości lub części Umowy, tak aby przywrócić jej pierwotne znaczenie.</li>
  <li>Wszelkie spory wynikające z Umowy lub z nią związane będą rozstrzygane na drodze polubownej, a w przypadku braku porozumienia pomiędzy stronami zostaną poddane rozstrzygnięciu przez sąd powszechny właściwy dla siedziby Zleceniodawcy.</li>
  <li>Umowa sporządzona została w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</li>
  <li>Integralną część Umowy stanowią:
    <ol class="special">
        <li>Klauzula informacyjna RODO</li>
        <li>Ogólne zasady bhp przy pracy administracyjno-biurowej</li>
        <li>Oświadczenie Zleceniobiorcy</li>
        <li>Szczegółowy zakres czynności</li>
        <li>Kodeks Etyki</li>
    </ol>
  </li>
</ol>
<br>

<div class="cointainer" style="margin-top: 30px; margin-bottom: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">{{zamawiajacy}}</span><br>
        <span style="margin-left: 0%;"><b>ZLECENIODAWCA</b></span>
    </div>
    <div class="right-cointainer">
        {{imieNazwisko}}<br>
        <span style="margin-left: 0%;"><b>ZLECENIOBIORCA</b></span>
    </div>
</div>

<div style="page-break-before: always;">
  <p><strong>Załącznik nr 1. KLAUZULA INFORMACYJNA</strong></p>
  <p>Klauzule informacyjne z art. 13 RODO</p>
  <p>Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (Dz. Urz. UE L 119 z 04.05.2016, str. 1), dalej „RODO”, informuję, że:</p>
  <p style="margin-bottom: 10px;">Administratorem Pani/Pana danych osobowych jest Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, zwany dalej: „ADO”.</p>
  <p style="margin-bottom: 10px;">Może Pan/Pani kontaktować się z ADO pisząc na adres: Tutore Poland Sp. z o.o, ul. Piotrkowska 157A, 90-440, mail kadry@tutore.eu oraz poprzez kontakt z Inspektorem Ochrony Danych na adres e-mail: mlokaj@mlkancelaria.com</p>
  <p>ADO przetwarza dane osobowe w celu:</p>
  <ol type="a">
    <li>nawiązania współpracy - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>zapewnienia kontaktu pomiędzy Stronami (adres  e – mail, nr telefonu) - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji praw i obowiązków wynikających z umowy o świadczenie usług - Art. 6 ust. 1 lit. b, c, f RODO,</li>
    <li>prowadzenia rejestru korespondencji - Art. 6 ust. 1 lit. c, f RODO,</li>
    <li>ewidencji przebiegu współpracy (w tym realizacja płatności) - Art. 6 ust. 1 lit. b, c RODO,</li>
    <li>dochodzenia roszczeń i praw - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji obowiązków podatkowych - Art. 6 ust. 1 lit. b, c RODO,</li>
  </ol>
  <br>
  <p style="margin-bottom: 10px;">Odbiorcami danych osobowych są podmioty, którym ADO powierzył przetwarzanie danych osobowych, w szczególności: dostawcy usług technicznych i organizacyjnych, dostawcy usług księgowych, kadrowych, prawnych i doradczych, banki (realizacja płatności), organy publiczne w ramach realizacji obowiązków związanych z prowadzeniem działalności gospodarczej przez ADO.</p>
  <p style="margin-bottom: 10px;">ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</p>
  <p style="margin-bottom: 10px;">Dane osobowe przechowywane będą przez okres realizacji umowy, a następnie przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa, w tym w szczególności: dochodzenie roszczeń (okres przedawnienia roszczeń), prowadzenie ksiąg rachunkowych i dokumentacji podatkowej (5 lat od końca roku kalendarzowego, w którym powstał obowiązek podatkowy).</p>
  <p style="margin-bottom: 10px;">Osoba, której dane są przetwarzane ma prawo dostępu do swoich danych oraz otrzymania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do usunięcia danych, prawo do cofnięcia zgody, prawo do ograniczenia przetwarzania, prawo do bycia zapomnianym, prawo do sprzeciwu, prawo do przenoszenia danych, prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</p>
  <p style="margin-bottom: 10px;">Podanie przez Panią/Pana danych osobowych oraz zgoda na ich przetwarzanie i rozpowszechnianie wizerunku jest dobrowolne, ale stanowi warunek konieczny dla nawiązania współpracy i ewentualnego zawarcia umowy w formie pisemnej oraz realizacji praw i obowiązków przez ADO.</p>
  <p style="margin-bottom: 10px;">W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</p>
  <p style="margin-bottom: 10px;">Zakres danych podlegający przetwarzaniu: imię i nazwisko, adres mailowy, numer telefonu, wizerunek, PESEL.</p>
</div>
  
<div style="page-break-before: always;">
  <p><em><b>Załącznik nr 2</b></em></p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>OGÓLNE ZASADY BHP PRZY PRACY ADMINISTRACYJNO-BIUROWEJ</strong></p>
  <br>
  <p>Bezpieczne warunki pracy są zapewnione, gdy:</p>
  <ul>
    <li>Zapewniona jest dostatecznie duża powierzchnia stanowiska pracy (co najmniej 2m wolnej powierzchni podłogi).</li>
    <li>Jest właściwe oświetlenie (w zależności od charakteru pracy min. 300lx).</li>
    <li>Jest dostateczna wentylacja pomieszczenia (naturalna lub mechaniczna); wilgotność względna powietrza nie powinna być mniejsza niż 40%.</li>
    <li>Jest wystarczające ogrzewanie w okresie jesienno-zimowym (min. +18°C)</li>
    <li>Są dostępne i w dobrym stanie urządzenia higieniczno-sanitarne oraz dobry stan techniczny mebli, sprzętu i innych urządzeń.</li>
  </ul>
  <p>Podstawowe czynności, które należy wykonać przed rozpoczęciem pracy:</p>
  <ul>
    <li>Zaplanować  kolejność wykonywania poszczególnych czynności, przygotować potrzebne dokumenty i programy.</li>
    <li>Ustawić ekran monitora względem źródeł światła tak, aby ograniczyć olśnienie i odbicia światła.</li>
    <li>Sprawdzić stan techniczny mebli, sprzętu, urządzeń, stan oświetlenia stanowiska pracy.</li>
    <li>Zaznajomić się dokładnie z instrukcją obsługi i instrukcją bezpiecznej pracy sprzętu elektrycznego i elektronicznego używanego w trakcie wykonywania pracy (komputer, drukarka, itp.).</li>
    <li>Odpowiednio dla siebie dopasować krzesło i przygotować stanowisko pracy.</li>
    <li>Czynności, które należy wykonywać podczas pracy:</li>
    <li>Utrzymywać ład i porządek na stanowisku pracy.</li>
    <li>Zachowywać ostrożność przy używaniu urządzeń elektrycznych.</li>
    <li>Czynności zabronione:</li>
    <li>Dopuszczenia do użytkowania urządzeń osób nieupoważnionych.</li>
    <li>Otwierania osłon podczas pracy urządzeń.</li>
    <li>Używania niesprawnych bądź uszkodzonych urządzeń, względnie instalacji elektrycznej (np. zniszczona izolacja na przewodach, stłuczone wtyczki lub gniazdka, prowizorycznie połączone przewody). </li>
  </ul>
  <p>Uwagi końcowe:</p>
  <ul>
    <li>
        Przy stałej pracy przy komputerze należy:
        <ul>
            <li>łączyć przemiennie prace związana z obsługą monitora ekranowego z innymi rodzajami prac nie obciążającymi narządu wzroku i wykonywanymi  w innych pozycjach ciała – przy nieprzekraczaniu 1 godziny nieprzerwanej pracy przy obsłudze monitora ekranowego lub</li>
            <li>co najmniej 5-minutową przerwę, wliczaną do czasu pracy, po każdej godzinie pracy przy obsłudze monitora ekranowego.</li>
        </ul>
    </li>
  </ul>
  <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższa zasady bhp przy pracy administracyjno-biurowej.</p>
  <div style="margin-top: 40px; font-size: 10px;">
    <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
    <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
  </div>
</div>


</td>
</tr>

</tbody></table>

    <div style="margin-top:5px;page-break-before: always;">
  <p><em><b>Załącznik nr 3. Oświadczenie Zleceniobiorcy</b></em></p>
  <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>

  <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
  <tbody>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
  <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Data</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{data}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Imiona i nazwisko</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{imieNazwisko}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer PESEL</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{pesel}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrDowodu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Obywatelstwo</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwo}}</span></p>
  </td>
  </tr>

  <tr v-if="obywatelstwoA">
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>A. Posiadam na terytorium Rzeczypospolitej Polskiej centrum interesów osobistych lub gospodarczych (ośrodek interesów życiowych*):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwoA}}</span></p>
  </td>
  </tr>

  <tr v-if="obywatelstwoB">
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>B. Przebywam na terytorium Rzeczypospolitej Polskiej dłużej niż 183 dni w roku kalendarzowym (podatkowym):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwoB}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer telefonu</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrTelefonu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres e-mail</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{email}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Adres zamieszkania</span>
    <br>
    <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
  </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{zamieszkany}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Adres korespondencyjny</span>
    <br>
    <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
  </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{korespondencyjny}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Urząd Skarbowy</span>
    <br>
    <span>(zgodny z adresem zamieszkania)</span>
    </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{urzadSkarbowy}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrRachunku}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany)</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{emeryt}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{rencista}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{orzeczenieNiepelnosprawnosc}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia (nie dotyczy studiów doktoranckich, podyplomowych):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{student}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe (tylko w przypadku objęcia obowiązkowym ubezpieczeniem emerytalnym i rentowym):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{chorobowe.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę/umowę zlecenie: (Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy/zleceniodawcy poza Tutore Poland Sp. z o.o. (proszę wypełnić w przypadku odpowiedzi TAK w pkt. 6):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nazwaUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie w innym miejscu niż Tutore Poland Sp. z o.o. jest wyższe bądź równe krajowej płacy minimalnej.</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>
  
  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.3. Wnoszę o dobrowolne ubezpieczenie emerytalne i rentowe (tylko w przypadku odpowiedzi TAK w pkt. 6 i 6.2):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{ubezpieczenieEmerytalne.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu niż umowa zlecenie z Tutore Poland Sp. z o.o. (np. zasiłek macierzyński, rodzicielski, urlop wychowawczy, własna pozarolnicza działalność gospodarcza):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{ubezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{tytulUbezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
  <p class="cell-in-first-table"><span style="font-size: 12px"><strong>
  Wypełnienie powyższego oświadczenia oznacza zgodę na podanie Tutore Poland Sp. z o.o. numeru telefonu, e-mail i adresu do korespondencji, jak również oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym, oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
  <br/>
  W przypadku zmiany ww. danych w trakcie trwania umowy zlecenie, zobowiązuję się do poinformowania Zleceniodawcy w terminie 7 dni od daty zaistnienia zmiany. Wszelkie szkody wynikające ze zmiany treści oświadczeń zobowiązuje się pokryć z własnych środków.
  <br/>
  </strong></span></p>
  </td>
  </tr>

  </tbody>
  </table>
  </div>

  <div style="page-break-before: always;">
    <p><strong>Załącznik nr 4.</strong></p>
    <p><b>Szczegółowy zakres czynności zleconych do wykonania, o którym mowa w § 1 ust. 2 Umowy.</b></p>
    <p>Zleceniobiorca zobowiązuje się:</p>
    <ol>
      <li>
        Wykonywać czynności związane z czynnościami porządkowymi, a w szczególności:
        <br>
        Wykonywać czynności porządkowe w salach wykładowych, pomieszczeniach biurowych, na korytarzach i w innych zlecanych powierzchniach w budynku:
        <ol type="a">
          <li>1 x dziennie:
            <ul>
              <li>starcie kurzu z mebli i urządzeń biurowych,</li>
              <li>umycie blatów i biurek,</li>
              <li>umycie wszystkich urządzeń sanitarnych w łazience / łazienkach,</li>
              <li>uzupełnienie dozowników na mydło i papieru toaletowego,</li>
              <li>umycie podłóg.</li>
            </ul>
          </li>
          <li>
            1 x w tygodniu:
            <ul>
              <li>starcie kurzu z parapetów i drzwi,</li>
              <li>pastowanie podłóg.</li>
            </ul>
          </li>
          <li>
            1 x w miesiącu:
            <ul>
              <li>umycie parapetów i drzwi</li>
              <li>umycie kaloryferów i kloszy lamp.</li>
            </ul>
          </li>
          <li>
            2 x w roku:
            <ul>
              <li>umycie okien,</li>
              <li>umycie lamperii</li>
            </ul>
          </li>
        </ol>
      </li>
      <li>Chronić powierzone mu przez Zleceniodawcę hasła dostępu oraz klucze do placówki, w której realizowane będą Usługi, przed zgubieniem bądź kradzieżą. W przypadku konieczności dorobienia kluczy, wymiany zamka w drzwiach, wezwania ochrony itp. z winy Zleceniobiorcy, Zleceniobiorca zobowiązany jest pokryć koszty takiego zdarzenia samodzielnie lub zwrócić je Zleceniodawcy na podstawie refaktury w ciągu 14 dni od jej otrzymania.</li>
      <li>Segregować odpady i śmieci Zleceniodawcy oraz gromadzić zebrane odpady w miejscach do tego wyznaczonych, jak również wynosić je na śmietniki wskazane przez Zleceniodawcę zgodnie z zasadami segregacji obowiązującymi w placówce, w której realizowane będą Usługi. Zleceniobiorca zobowiązuje się nie wyrzucać odpadów powstałych w wyniku realizacji przez niego Usług w miejscach do tego nieprzeznaczonych.</li>
      <li>Zleceniobiorca zobowiązuje się, że nie będzie przeglądać żadnych dokumentów, akt czy rysunków, otwierać szuflad, jak również segregować czy porządkować dokumentów znajdujących się w sprzątanych pomieszczeniach oraz że nie będzie korzystać z telefonów, komputerów i innych urządzeń technicznych Zleceniodawcy.</li>
    </ol>

    <div class="cointainer" style="margin-top: 30px; margin-bottom: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">{{zamawiajacy}}</span><br>
        <span style="margin-left: 0%;">Podpis Zleceniodawcy</span>
    </div>
    <div class="right-cointainer">
        {{imieNazwisko}}<br>
        <span style="margin-left: 0%;">Podpis Zleceniobiorcy</span>
    </div>
</div>
  </div>

  <div style="margin-top: 5px;page-break-before: always;">
    <p><em><b>Załącznik nr 5 Kodeks Etyki</b></em></p>
     Wstęp
     <p>W Grupie Tutore wierzymy, że etyczne i odpowiedzialne działanie to fundament zaufania, zarówno w edukacji, jak i w biznesie. Niniejszy Kodeks Etyki przedstawia wartości i zasady, którymi kierujemy się w naszej codziennej pracy. Kodeks określa standardy postępowania, które wspólnie z naszymi partnerami biznesowymi chcemy budować i rozwijać. Grupa Tutore prowadzi działalność zawodową w sposób profesjonalny oraz odpowiedzialny, zarówno społecznie jak i środowiskowo, z poszanowaniem norm etycznych i przepisów prawa. W celu zapewnienia standardów działalności, dokonujemy wyboru partnerów biznesowych w oparciu o wartości wskazane w Kodeksie Etyki. Grupa wspiera swoich partnerów biznesowych w poszanowaniu Kodeksu, udzielając wszelkich niezbędnych wyjaśnień na każde zapytanie aktualnego lub potencjalnego partnera biznesowego.</p>
     Standardy działalności Grupy
     <p>Nasze działania są oparte na uczciwości, odpowiedzialności i jakości, czyli kluczowych wartościach w branży edukacyjnej. W relacjach z partnerami biznesowymi oraz klientami, Spółki Grupy Tutore kierują się zasadami równego traktowania, transparentności oraz otwartości. Grupa szczególny nacisk kładzie na przestrzeganie przepisów o uczciwej konkurencji, ochronie konsumentów i ochronie danych osobowych. Nieustannie podnosimy jakość świadczonych usług, inwestując w innowacje, rozwój i doskonalenie procesów. Grupa nieustannie rozwija systemy kontroli i audytu, aby zapewnić najwyższe standardy funkcjonowania Spółek.</p>
     Prawa człowieka, prawa dziecka
     <p>Grupa Tutore kładzie nacisk na przestrzeganie fundamentalnych praw i wolności, w szczególności takich jak prawo do życia, zdrowia, zachowania integralności, godności i wolności, prawo do swobodnego wyrażania myśli i słowa, a także prawo do rozwoju. Jako organizacja edukacyjna przykładamy szczególną wagę do standardów ochrony małoletnich oraz potwierdzamy, że Spółki Grupy nie korzystały, nie korzystają i nie zamierzają wykorzystywać pracy dzieci ani pracy przymusowej w swojej działalności.</p>
     Prawa pracownicze
     <p>W Grupie Tutore dbamy o naszych pracowników i współpracowników, tworząc bezpieczne i przyjazne środowisko pracy. Przestrzegamy prawa pracy i stosujemy najwyższe standardy etyczne, zapewniając wszystkim równe szanse rozwoju zawodowego. Spółki zabraniają jakiejkolwiek dyskryminacji oraz wspierają różnorodność, otwartość i kulturę wzajemnego szacunku wśród pracowników i współpracowników. Grupa ustanawia Politykę antymobbingową i zobowiązuje się przedsięwziąć kroki w celu przeciwdziałania i zapobiegania wszelkim formom dyskryminacji i mobbingu.</p>
     Prawa zwierząt i środowisko naturalne
     <p>Działamy w sposób zgodny z przepisami dotyczącymi ochrony środowiska i praw zwierząt. Spółki Grupy zmierzają do zminimalizowania negatywnego wpływu na środowisko naturalne, zdrowie ludzi i zwierząt, podejmując działania ograniczające zużycie energii, emisję gazów cieplarnianych i produkcję odpadów. Nasze decyzje biznesowe uwzględniają troskę o przyszłe pokolenia.</p>
     Ochrona informacji
     <p>Poprzez wdrożenie właściwych polityk i procedur chronimy dane osobowe wszystkich osób i organizacji, z którymi współpracujemy: pracowników, współpracowników, klientów i partnerów. Grupa dba o bezpieczeństwo informacji poufnych, tajemnicy handlowej i know-how, zapewniając pełną zgodność z wymaganiami przepisów prawa krajowego, jak i międzynarodowego. W edukacji zaufanie jest kluczowe, dlatego bezpieczeństwo informacji traktujemy jako priorytet.</p>
     Zasady obowiązujące podmioty posiadające relacje biznesowe z Grupą
     <p>Grupa, jak i Spółki podchodzą do swoich partnerów biznesowych z szacunkiem oraz biznesową uczciwością. Zapraszamy partnerów do współpracy w oparciu o wspólne wartości etyczne oraz poszanowanie prawa krajowego i międzynarodowego. Partnerzy biznesowi Grupy nie mogą być objęci jakimikolwiek sankcjami finansowymi ani gospodarczymi, ani współpracować z podmiotami, których one dotykają. Zastrzegamy możliwość odmowy podjęcia współpracy lub zakończenia współpracy w sytuacjach naruszenia zasad etycznych Grupy.</p>
     Przeciwdziałanie przestępstwom, korupcji, defraudacji i innym nadużyciom
     <p>Grupa Tutore sprzeciwia się popełnianiu jakichkolwiek przestępstw, w szczególności przestępstw korupcji, przekupstwa, defraudacji środków, prania pieniędzy, finansowania terroryzmu oraz fałszerstwa pieniędzy, papierów wartościowych lub dokumentów. Każdy pracownik, współpracownik lub partner biznesowy Grupy, który zauważy lub otrzyma informację o nieprawidłowości, może skorzystać z anonimowej procedury zgłoszeń (ochrona sygnalistów), dostępnej na stronie tutorepoland.liniaetyki.pl.</p>
     Postanowienia końcowe
     <p>Kodeks Etyki ma zastosowanie i jest dostępny dla wszystkich pracowników, współpracowników, osób działających na rzecz/w imieniu Spółek, klientów oraz partnerów biznesowych Spółek Grupy. W ramach Grupy mogą być tworzone dodatkowe dokumenty, mające na celu uszczegółowienie zasad opisanych w niniejszym Kodeksie.</p>
     <p>Wszelkie zgłoszenia oraz zapytania związane z Kodeksem Etyki prosimy przesyłać na adres compliance@tutore.eu.</p>

     <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższy Kodeks Etyki.</p>
    <div style="margin-top: 40px; font-size: 10px;">
      <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
      <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
    </div>
    </div>
  
  </v-container>
</template>

<script>
export default {
  name: 'UmowaTechniczniCPProfi',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrumowy: '',
      datapocz: '',
      dataKonca: '',
      wypo: '',
      kwota: '',
      slowniepokaz: '',
      shortUmowa: '',
      obywatelstwo: '',
      stawka1: '',
      stawka2: '',
      stawka3: '',
      przedmiot: '',
      ubezpieczenieEmerytalne: '',
      obywatelstwoA: '',
      obywatelstwoB: '',
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      let shortPosition = ''
      tab = this.nrumowy.split('/')
      switch(tab[3]) {
        case 'Promocja':
          shortPosition = 'Prom'
          break;
        case 'Metodyk':
          shortPosition = 'Met'
          break
        case 'BOK':
          shortPosition = 'BOK'
          break
        case 'Techniczni - czynności porządkowe':
          shortPosition = 'TCP'
          break
        case 'Techniczni - działalność konserwatora budynków':
          shortPosition = 'TKB'
          break
        case 'Techniczni - ochrona mienia':
          shortPosition = 'TOM'
          break
        default:
          shortPosition = tab[3]
      }
      const shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      return shortUmowa
    },
    dataObowiazywaniaUmowy() {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'od dnia podpisania umowy przez obie strony do ' + this.dataKonca + ' r.'
      } else {
        return `od ${this.umowaOd} do ${this.dataKonca} r.`
      }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if((day+1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = day+'-'+month+'-'+today.getFullYear()
      return todayDate
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.right-cointainer {
  text-align: end;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.attachments {
  width: 100%;
}

ol.special {
    counter-reset: list;
}

ol.special > li {
    list-style: none;
}

ol.special > li:before {
    content: counter(list) ") ";
    counter-increment: list;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaTechniczniCPProfi.vue